let resumeData = {
  imagebaseurl: "https://abhikarmaker.github.io/portfolio/",
  name: "Abhijeet Karmaker",
  role: "Web Developer",
  linkedinId: "abhijeet-karmaker",
  githubid: "abhikarmaker",
  roleDescription:
    " I craft high-impact, modern web experiences with polished frontends and reliable full-stack architecture.",
  address1: "",
  address2: "",
  phoneNumber: "+1 8194342389",
  website: "https://easytechvancouver.ca",
  websiteLabel: "Owner of easytechvancouver.ca",
  aboutme: [
    {
      name: "My Experience",
      description:
        "I am a Senior QA Engineer with 7+ years of experience testing complex enterprise and infrastructure software. My background includes systems-level validation across distributed environments, virtualization stacks, networking, security controls, and cloud-integrated platforms.",
    },
    {
      name: "My Skillset",
      description:
        "I specialize in virtualization testing (VMware ESXi, Hyper-V, KVM, Proxmox), network and security validation, endpoint management integrations (Azure AD, SAML, SSO), database testing (MySQL, MSSQL, PostgreSQL, Oracle), and cloud/SaaS ecosystems including Azure, Microsoft 365, and SASE. I build scalable test environments with Docker and Kubernetes, and I automate workflows using Python, PyTest, Bash, and CI/CD pipelines (Jenkins, GitLab CI, GitHub Actions).",
    },
  ],
  socialLinks: [
    {
      name: "Linked In",
      id: "abhijeet-karmaker",
      url: "https://www.linkedin.com/in/abhijeet-karmaker/",
      className: "fa fa-linkedin",
    },
    {
      name: "GitHub",
      id: "abhikarmaker",
      url: "https://github.com/abhikarmaker",
      className: "fa fa-github",
    },
  ],
  education: [
    {
      id: "1",
      school: "Dr. M. G. R. Educational and Research Institute University",
      degree: "Bachelor of Technology",
      fieldofstudy: "Computer Science Engineering",
      MonthOfPassing: "May",
      YearOfPassing: "2014",
      address: "Chennai, Tamil Nadu, India",
      description:
        "Completed a three-month internship as a Junior Web Developer at Key Difference in Chennai, India in 2014.",
    },
    {
      id: "2",
      school: "Lambton College",
      degree: "Post Graduation Certificate",
      fieldofstudy: "Computer Software and Database Development",
      MonthOfPassing: "May",
      YearOfPassing: "2019",
      address: "Sarnia, Ontario, Canada",
      description: "Dean's Honour List, Winter 2018 and Fall 2017 semesters.",
    },
  ],
  work: [
    {
      id: "1",
      CompanyName: "Fortinet",
      Title: "Intermediate Software Dev QA Specialist",
      address: "Burnaby, British Columbia, Canada · Hybrid",
      StartingMonthAndYear: "Feb 2025",
      MonthOfLeaving: "Present",
      YearOfLeaving: "",
      achievements: [
        "Led the development and maintenance of complex testing systems involving numerous network components, ensuring rigorous coverage across all major areas.",
        "Collaborated closely with developers to design, develop, and implement manual and automated test cases, improving testing efficiency and accuracy.",
        "Configured and managed complex manual testing environments for an Endpoint Management System across Windows Server, Windows clients, and Linux systems.",
        "Carried out API testing with Postman and curl using HTTP methods to verify data and system behavior.",
        "Reviewed regression results and internal tracking reports, proactively identifying, reproducing, and documenting software defects.",
      ],
    },
    {
      id: "2",
      CompanyName: "Fortinet",
      Title: "Software Dev QA Specialist",
      address: "Vancouver, British Columbia, Canada",
      StartingMonthAndYear: "Aug 2021",
      MonthOfLeaving: "Feb",
      YearOfLeaving: "2025",
      achievements: [
        "Used SQL extensively to validate data in database tables through DDL, DQL, and DML operations.",
        "Performed CRUD-focused validation across tables, columns, and rows while ensuring data precision and consistency.",
        "Built strong working knowledge of DBMS and RDBMS concepts, including structured and unstructured data handling.",
        "Managed integration testing for Azure AD and Active Directory within the enterprise management application.",
        "Developed and executed test plans covering both manual validation and automation with PyTest for API and GUI workflows.",
        "Performed server-client and cloud application testing, including penetration testing activities and log analysis.",
      ],
    },
    {
      id: "3",
      CompanyName: "Sherweb",
      Title: "Microsoft 365 Technical Analyst Premier IV",
      address: "Sherbrooke, Quebec, Canada",
      StartingMonthAndYear: "March 2020",
      MonthOfLeaving: "July 2021",
      YearOfLeaving: "",
      achievements: [
        "Knowledge and experience in creating and running PowerShell scripts.",
        "Specialized in advanced Microsoft 365 products such as Exchange, Azure, SharePoint, and Teams.",
        "Assist Microsoft 365 Premier partners and customers by identifying causes and resolving technical issues through remote support and virtual machines.",
        "Tackle new technical challenges daily, including security, Azure AD, Autopilot, and device management.",
      ],
    },
    {
      id: "6",
      CompanyName: "Rance Computer Pvt. Ltd",
      Title: "Software Testing Engineer",
      address: "Kolkata, West Bengal, India",
      StartingMonthAndYear: "Dec 2014",
      MonthOfLeaving: "August",
      YearOfLeaving: "2017",
      achievements: [
        "Worked on manual and automated testing of GUI and functional aspects of client-server and web-based applications across multiple stages of the SDLC and STLC.",
        "Built a solid foundation in object-oriented programming concepts and Java.",
        "Created test scripts using WebDriver, Selenium RC, Selenium IDE, and Selenium Grid in Java.",
        "Performed functional, regression, and system testing with manual and automated tools including Selenium WebDriver.",
        "Logged bugs in tracking systems such as JIRA and Mantis, then carried out regression testing after fixes.",
        "Performed end-to-end, integration, and user acceptance testing.",
      ],
    },
  ],
  certifications: [
    {
      id: "1",
      name: "Fortinet Network Security Expert Level 2: Certified Associate",
      issuingOrganization: "Fortinet",
      issueDate: "December 2022",
      credential: "",
    },
    {
      id: "2",
      name: "Fortinet Network Security Expert Level 1: Certified Associate",
      issuingOrganization: "Fortinet",
      issueDate: "December 2021",
      credential: "",
    },
    {
      id: "3",
      name: "Verified International Academic Qualifications",
      issuingOrganization: "World Education Services",
      issueDate: "April 2021",
      credential: "Show credential",
    },
    {
      id: "4",
      name: "Oracle Database 11g: SQL Fundamentals I",
      issuingOrganization: "Dr. MGR Educational & Research Institute University",
      issueDate: "January 2014",
      credential: "Credential ID 50104953",
    },
    {
      id: "5",
      name: "Microsoft 365 Certified: Fundamentals",
      issuingOrganization: "Microsoft",
      issueDate: "December 2020",
      credential: "",
    },
  ],
  skillsDescription:
    "Frontend, backend, testing, and collaboration skills built through production support and web development work.",
  skills: [
    {
      id: "1",
      skillname: "JAVA",
      className: "fa fa-code",
    },
    {
      id: "2",
      skillname: "HTML5",
      className: "fa fa-html5",
    },
    {
      id: "3",
      skillname: "CSS",
      className: "fa fa-css3",
    },
    {
      id: "4",
      skillname: "JavaScript",
      className: "fa fa-code",
    },
    {
      id: "5",
      skillname: "Reactjs",
      className: "fa fa-code-fork",
    },
    {
      id: "6",
      skillname: "SQL",
      className: "fa fa-table",
    },
    {
      id: "7",
      skillname: "Python",
      className: "fa fa-code",
    },
    {
      id: "8",
      skillname: "Kubernetes",
      className: "fa fa-sitemap",
    },
  ],
  portfolio: [
    {
      id: "1",
      name: "Portfolio",
      description:
        "A personal portfolio built with React and local JSON-based content, designed and developed from scratch.",
      imgurl: "images/portfolio/project2.jpg",
      link: "https://abhikarmaker.github.io/portfolio/",
      githubLink: "https://github.com/abhikarmaker/portfolio",
      fabIcon: "fa fa-github",
    },
    {
      id: "2",
      name: "Weather App",
      description: "A weather app built with React, REST APIs, and Bootstrap.",
      imgurl: "images/portfolio/project3.jpg",
      link: "https://weather-app-b731e.web.app/",
      githubLink: "https://github.com/abhikarmaker/WeatherReactApp",
      fabIcon: "fa fa-github",
    },
    {
      id: "3",
      name: "Netflix Clone",
      description:
        "A Netflix-inspired UI built with React, Hooks, React YouTube, and TMDB data.",
      imgurl: "images/portfolio/Netflix-Clone.jpg",
      link: "https://netflixstma-clone.web.app/",
      githubLink: "https://github.com/abhikarmaker/netflixstma-clone",
      fabIcon: "fa fa-github",
    },
    {
      id: "4",
      name: "Kitchen Depot",
      description:
        "A college project built with HTML5, CSS, JavaScript, jQuery, and JSON.",
      imgurl: "images/portfolio/project1.jpg",
      link: "https://abhikarmaker.github.io/THE-KITCHEN-DEPOT-FINAL/",
      githubLink: "https://github.com/abhikarmaker/THE-KITCHEN-DEPOT-FINAL",
      fabIcon: "fa fa-github",
    },
  ],
  easyTech: {
    kicker: "Owner spotlight",
    title: "EasyTech Vancouver",
    description:
      "I also run EasyTech Vancouver, a local IT support and digital solutions service focused on approachable technical help for homes, small businesses, and the Metro Vancouver community.",
    highlights: [
      "Owner-led local IT consulting and troubleshooting",
      "Friendly support for devices, connectivity, and digital setup",
      "Clear communication with practical, client-focused solutions",
    ],
    website: "https://easytechvancouver.ca",
    phone: "+1 8194342389",
    logoImage: "images/easytech-logo.png",
    bannerImage: "images/easytech-banner.png",
  },
  techForDad: {
    kicker: "Owner spotlight",
    title: "Tech For Dad",
    description:
      "I also own TechForDad.com — a trusted review site helping seniors and their families choose the right technology. Every product is hands-on tested by real caregivers, with no sponsored rankings, ever.",
    highlights: [
      "30+ products hands-on tested by real caregivers",
      "No sponsored rankings — performance and value only",
      "Updated monthly with new products and price changes",
    ],
    categories: [
      { icon: "🆘", label: "Medical Alert Systems", url: "https://www.techfordad.com/blog/best-medical-alert-systems.html" },
      { icon: "📱", label: "Senior Phones", url: "https://www.techfordad.com/blog/best-cell-phones-for-seniors.html" },
      { icon: "💻", label: "Tablets", url: "https://www.techfordad.com/blog/best-tablets-for-seniors.html" },
      { icon: "📍", label: "GPS Trackers", url: "https://www.techfordad.com/blog/best-gps-trackers-for-seniors.html" },
      { icon: "❤️", label: "Blood Pressure Monitors", url: "https://www.techfordad.com/blog/best-blood-pressure-monitors-for-seniors.html" },
    ],
    stats: [
      { value: "30+", label: "Products Tested" },
      { value: "5", label: "Review Categories" },
      { value: "0", label: "Sponsored Rankings" },
      { value: "Monthly", label: "Updates" },
    ],
    website: "https://techfordad.com",
    bannerImage: "images/techfordad-banner.png",
  },
};

export default resumeData;
